import { styled } from 'styled-components';
import { Checkbox, Select } from 'antd';
import { flexMixin, textMixin } from '@styles/mixins';
import { colors } from '@styles';

export const FooterWrap = styled.div`
    ${flexMixin('row', 'flex-start', 'center')}
`;

export const ActionWrap = styled.div`
    ${flexMixin('row', 'flex-start', 'center')}
    gap: 10px;
`;

export const StyledSelect = styled(Select)`
    box-sizing: border-box;
    ${flexMixin('row', 'center', 'center')}
    gap: 10px;
    width: 175px;
    height: 38px;
`;
export const StyledActionButton = styled.button`
    ${flexMixin('row', 'center', 'center')}
    padding: 5px 10px;
    gap: 10px;
    width: 98px;
    height: 38px;
    background: ${colors.primaryBg};
    border-radius: 5px;
    border: none;
    cursor: pointer;
    & span {
        width: 78px;
        height: 28px;
        ${textMixin({
            fontSize: '14px',
            fontWeight: 500,
        })};
        line-height: 28px;
        display: flex;
        align-items: center;
        color: ${colors.bgWhite};
        flex: none;
        order: 0;
        flex-grow: 0;
    }
`;
export const StyledCheckbox = styled(Checkbox)`
    ${flexMixin('row', 'center', 'center')}
`;

export const SearchWrap = styled.div`
    ${flexMixin('row', 'space-between', 'center')}
    width: 100%;
`;
export const SearchInput = styled.input`
    width: 90%;
    padding-left: 20px;
    height: 33px;
    background: ${colors.cleanWhite};
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    border: none;
`;
export const ButtonBlock = styled.div`
    ${flexMixin('row', 'space-between', 'center')}
    gap: 5px;
`;
export const StyledButton = styled.button`
    width: 33px;
    height: 33px;
    background: #cd6ee5;
    box-sizing: border-box;
    border: 1px solid #cd6ee5;
    box-shadow: -1px 1px 4px 1px rgba(0, 0, 0, 0.24);
    border-radius: 3px;
    padding: 5px;
    cursor: pointer;
`;

export const TableWrapper = styled.div`
    width: 100%;

    .ant-table-thead {
        height: 40px;
        background: rgba(148, 129, 205, 0.25);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px 5px 0 0;
    }
    .ant-table-thead > tr > th::before {
        content: none !important;
    }
    .ant-table-cell {
        border-right: none !important;
        border-left: none !important;
        font-size: 14px !important;
    }

    .ant-table-row .ant-table-cell {
        height: 40px !important;
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 28px;
        align-items: center;
        color: ${colors.grey};

        & svg {
            margin-top: 9px;
        }
    }

    .ant-table-header {
        overflow: hidden !important;
    }
`;

export const HeaderTitle = styled.div`
    margin-top: 38px;
    width: 110px;
    height: 28px;
    ${textMixin({
        fontSize: '25px',
        fontWeight: 600,
    })};
    line-height: 28px;
    align-items: center;
    color: ${colors.grey};
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    min-height: 90%;
    top: 0;
    gap: 16px;
    background-color: ${colors.bgWhite};

    .ant-table-row {
        height: 14px !important;
        padding: 2px !important;
    }

    .ant-table-cell {
        height: 14px !important;
        padding: 2px !important;
    }

    .ant-table-tbody > tr > td {
        background-color: ${colors.cleanWhite};
        border: 1px solid #efefef;
        color: ${colors.grey};
        ${textMixin({
            fontSize: '12px',
            fontWeight: 400,
        })};
        line-height: 12px;
        text-align: left;
        padding: 2px;
        height: 12px;
    }

    .ant-table-summary {
        background-color: #9481cd40;
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 17px;
        text-align: left;
    }

    .ant-table-thead > tr > th {
        background-color: #9481cd40;
        ${textMixin({
            fontSize: '12px',
            fontWeight: 600,
        })};
        line-height: 13px;
        text-align: left;
    }
`;

export const Header = styled.div`
    width: 100%;
    height: 40px;
    ${flexMixin('column', 'space-between', 'flex-start')}
    top: 0;
    margin-bottom: 20px;
`;

export const Overlay = styled.div<{
    display: string;
}>`
    display: ${({ display }) => display};
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(1px);
`;
export const IconWrapper = styled.div`
    ${flexMixin('column', 'center', 'center')}
    width: 24px;
    height: 24px;
`;
